import React from 'react';
import PropTypes from 'prop-types';

const Location = (props) => {
	const { address } = props.data.location;
	const mapStyle = {
		height: `${props.moduleProps.map_height}px`,
	};

	return (
		<iframe className="people-module__location" title={address} src={`//maps.google.com/maps?q=${address}&z=15&output=embed`} frameBorder="0" style={mapStyle} />
	);
};

Location.propTypes = {
	data: PropTypes.object.isRequired,
	moduleProps: PropTypes.object.isRequired,
};

export default Location;



// WEBPACK FOOTER //
// ./wp-content/plugins/core/assets/theme/js/src/divi/people/parts/location.js